exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "footer {\n  min-height: 120px;\n  margin-top: 5px;\n}\n.footerContent {\n  width: 100%;\n  height:100%;\n  color: #000000 !important;\n  box-shadow: inset 4px 6px 10px -4px rgba(0, 0, 0, 0.3), 0 1px 1px -1px rgba(255, 255, 255, 0.3)!important;\n  background: rgba(0, 0, 0, 0.2) !important;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/backend/NasheDelo/WebLombard/client/src/app/footer/footer.component.css
// module id = ../../../../../src/app/footer/footer.component.css
// module chunks = 0